module.exports = __webpack_public_path__ + "app/assets/images/man8-a14eb4a2c7dd7ff1c868a57025ca162a.jpg";